import Phaser from 'phaser';
import { COLORS } from '../config';
import { formatNumber } from '../utils/formatNumber';

export class GoldDisplay {
  private scene: Phaser.Scene;
  private text: Phaser.GameObjects.Text;
  private icon: Phaser.GameObjects.Graphics;
  private glowGfx: Phaser.GameObjects.Graphics;
  private multiplierText: Phaser.GameObjects.Text;
  private anchorX: number;
  private anchorY: number;
  private goldRushActive: boolean = false;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    this.scene = scene;
    this.anchorX = x;
    this.anchorY = y;

    this.glowGfx = scene.add.graphics();
    this.icon = scene.add.graphics();

    // Right-aligned text: grows leftward from anchor
    this.text = scene.add.text(x, y, '0', {
      fontSize: '20px',
      fontFamily: 'Arial Black, Arial, sans-serif',
      color: '#FFD700',
    }).setOrigin(1, 0); // right-aligned

    // Multiplier badge (hidden by default)
    this.multiplierText = scene.add.text(x + 4, y, '', {
      fontSize: '14px',
      fontFamily: 'Arial Black, Arial, sans-serif',
      color: '#FFEE44',
      stroke: '#886600',
      strokeThickness: 2,
    }).setOrigin(0, 0).setVisible(false);

    this.drawIcon();
  }



  private lastText: string = '';
  private lastMultiplier: string = '';
  private lastGlowAlpha: number = -1;

  setGoldRush(active: boolean, multiplier: number): void {
    if (this.goldRushActive !== active) {
      this.goldRushActive = active;
      this.multiplierText.setVisible(active);
      if (!active) this.lastGlowAlpha = -1; // reset glow cache
    }

    if (active) {
      const newMult = `${multiplier}x`;
      if (this.lastMultiplier !== newMult) {
        this.multiplierText.setText(newMult);
        this.lastMultiplier = newMult;
      }
    }
  }

  update(gold: number): void {
    const newText = formatNumber(gold);
    if (this.lastText !== newText) {
      this.text.setText(newText);
      this.lastText = newText;
      this.drawIcon(); // Redraw icon if text width changed
    } else if (this.goldRushActive) {
      // Only need to redraw icon if we are animating the glow
      this.drawIcon();
    }
  }

  private drawIcon(): void {
    this.icon.clear();
    const textLeft = this.anchorX - this.text.width;
    const ix = textLeft - 12;
    const iy = this.anchorY + 8;
    this.icon.fillStyle(COLORS.gold, 1);
    this.icon.fillCircle(ix, iy, 7);
    this.icon.fillStyle(0xdaa520, 1);
    this.icon.fillCircle(ix, iy, 4);

    // Glow effect when gold rush active
    if (this.goldRushActive) {
      const time = this.scene.time.now;
      const alpha = 0.25 + 0.15 * Math.sin(time * 0.005);

      // Throttle glow redraws to reasonable alpha changes
      if (Math.abs(this.lastGlowAlpha - alpha) > 0.02) {
        this.glowGfx.clear();
        this.glowGfx.fillStyle(COLORS.gold, alpha);
        this.glowGfx.fillCircle(ix, iy, 13);
        this.lastGlowAlpha = alpha;
      }
    } else {
      this.glowGfx.clear();
    }
  }

  getTextLeft(): number {
    return this.anchorX - this.text.width;
  }
}
